<template>
	<div class="move">
		<p class="move__desc">리뷰 전체를 어느 제품으로 이동하시겠어요?</p>
		<product-selector v-model="selectedId" />
		<div class="btn-wrap-main">
			<button class="btn-main blue bordered" @click="close">닫기</button>
			<button class="btn-main blue" @click="move">이동</button>
		</div>
		<table class="table-main move__table">
			<thead>
				<tr>
					<th colspan="3">
						이동시킬 제품(A)과 이동될 제품(B)에 동일한 유저의 리뷰가
						있는 경우
					</th>
				</tr>
				<tr>
					<th>A</th>
					<th>B</th>
					<th>처리방식</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>정상</td>
					<td>정상</td>
					<td>유지</td>
				</tr>
				<tr>
					<td>블라인드, 검수중</td>
					<td>정상</td>
					<td>유지</td>
				</tr>
				<tr>
					<td>블라인드</td>
					<td>검수중</td>
					<td>유지</td>
				</tr>
				<tr>
					<td>블라인드</td>
					<td>블라인드</td>
					<td>유지</td>
				</tr>
				<tr>
					<td>검수중</td>
					<td>검수중</td>
					<td>유지</td>
				</tr>
				<tr>
					<td>정상</td>
					<td>블라인드, 검수중</td>
					<td>교체</td>
				</tr>
				<tr>
					<td>검수중</td>
					<td>블라인드</td>
					<td>교체</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
	import { mapState } from 'vuex';
	import ProductSelector from '@/components/ProductSelector';

	export default {
		name: 'ProductReviewMove',
		components: {
			ProductSelector,
		},
		data() {
			return {
				selectedId: null,
			};
		},
		computed: {
			...mapState({
				idProduct: state => state.ProductController.idProduct,
			}),
		},
		methods: {
			close() {
				this.$store.commit('modal/toggleModal', false);
			},
			async move() {
				try {
					if (!this.selectedId) {
						alert('선택된 제품이 없습니다.');
						return;
					}
					if (!confirm('모든 리뷰를 이동하시겠습니까?')) {
						return;
					}
					const params = { targetIdProduct: this.selectedId };
					const { data } = await this.$axiosAdmin2.post(
						`/api/products/${this.idProduct}/reveiw/AllMove`,
						null,
						{ params }
					);
					this.$store.commit('modal/toggleModal', {
						id: 'ProductReviewMoveResult',
						params: { ...data },
					});
				} catch (err) {
					console.error(err);
					alert('리뷰이동에 실패했습니다. 개발팀에 문의하세요.');
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.move__desc {
		margin: 18px 0;
	}

	.move__table {
		th,
		td {
			height: auto;
			padding: 8px;
			text-align: left;
		}
	}
</style>
